module.exports = "//d274d294w9cx2v.cloudfront.net/ba955629db5d1c0740a409818593d6f2aac6df1c/images/venmoBadge.png";